import React, { useEffect, useRef, useState } from "react";
import { Button, FormControlLabel, FormGroup, Switch } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { FormControl, Input, InputLabel } from "@mui/material";

const CompanyEditModal = (props) => {
	
	const companyName = useRef(null);
 	let [ companyBranding, setCompanyBranding ] = useState(null);
	
	useEffect(() => {
		if (props.company) setCompanyBranding(props.company.company_branding);
	}, [props.company])
	
	const handleClose = () => {
		props.onClose()
	};
	
	const handleSubmit = () => {
		let company = props.company;
		company.name = companyName.current.value;
		company.company_branding = companyBranding;
		props.onSubmit(company);
	};
	
	const handleSubmitForm = (e) => {
		e.preventDefault();
		handleSubmit();
	};
	
	const handleCancel = () => {
		props.onClose()
	};
	
	const handleCompanyBrandingSwitch = (event) => {
		setCompanyBranding(event.target.checked);
	};
	
	const formControlStyle = {
		width: "80%",
		maxWidth: "35em",
		margin: "1em auto",
		display: "flex",
		lexDirection: "row",
		flexGrow: 1
	};
	
	return (
		<Dialog
			open={props.company? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title">
				Edit Company
			</DialogTitle>
			<DialogContent>
				<form onSubmit={handleSubmitForm} autoComplete="off">
					<FormControl sx={formControlStyle}>
						<InputLabel htmlFor="companyName">Company Name</InputLabel>
						<Input
							inputRef={companyName}
							id="companyName"
							defaultValue={props.company? props.company.name : ""}
						/>
					</FormControl>
					<FormGroup sx={formControlStyle}>
						<FormControlLabel
							control={
								<Switch
									checked={companyBranding}
									onChange={handleCompanyBrandingSwitch}
								/>
							}
							label="Enable Custom Branding"
						/>
					</FormGroup>
				</form>
			</DialogContent>
			<DialogActions>
				<React.Fragment>
					<Button onClick={handleCancel}>Cancel</Button>
					<Button onClick={handleSubmit} autoFocus>Submit</Button>
				</React.Fragment>
			</DialogActions>
		</Dialog>
	);
};

export default CompanyEditModal;